import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { member, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid #1f5d5b',
          borderTop: '4px solid transparent',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (!member) {
    return <Navigate to="/members" replace />;
  }

  return children;
};

export default ProtectedRoute;
